import h from 'hyperscript';

import i18n from 'cadenza/processes/messages.properties';
import { createProcessesList } from 'cadenza/processes/processes-list';
import { focusFirst } from 'cadenza/utils/event-util';
import { logger } from 'cadenza/utils/logging';

import './processes.css';

/*
 * - First show a progress spinner
 * - When the processes are loaded, show them in a list and if necessary with a selector select on top.
 * - If there are no processes, show a corresponding info message.
 * - In case of an error, show an error message.
 */
export function createProcessesContent (processesLoader) {
  const progressSpinner = h('d-progress-spinner.d-progress-spinner-column', { label: i18n('loading') });
  processesLoader()
    .then(contextsWithProcessings => {
      if (contextsWithProcessings.length && contextsWithProcessings[0].processing.length) {
        if (contextsWithProcessings.length > 1) {
          const processesBySelector = Object.fromEntries(contextsWithProcessings.map(({ selectorName, processing }) => [ selectorName, processing ]));
          const onChangeSelector = () => {
            selectorSelect.nextElementSibling?.remove();
            const processes = processesBySelector[selectorSelect.value];
            selectorSelect.after(createProcessesList(processes));
          };
          const selectorSelect = h('select.form-control', { onchange: onChangeSelector }, contextsWithProcessings.map(
            ({ selectorName, selectorLabel }) => h('option', { value: selectorName }, selectorLabel)));
          progressSpinner.replaceWith(selectorSelect);
          selectorSelect.focus();
          onChangeSelector();
        } else {
          const processesList = createProcessesList(contextsWithProcessings[0].processing);
          progressSpinner.replaceWith(processesList);
          focusFirst(processesList);
        }
      } else {
        progressSpinner.replaceWith(h('.d-alert.d-alert-info', i18n('noProcesses')));
      }
    })
    .catch(error => {
      logger.error('Failed to display the list of processings', error);
      progressSpinner.replaceWith(h('d-alert', {
        type: 'error',
        title: i18n('loading.error'),
        message: i18n('common:defaultErrorMessage')
      }));
    });
  return h('.d-processes', progressSpinner);
}
